<div class="payment-methods-card">
  <h3 class="payment-methods-title">{{ titleKey | translate }}</h3>

  <div class="methods-grid" [ngClass]="{
      'methods-grid--cols-2': !hasApplePay,
      'methods-grid--cols-3': hasApplePay
    }">
    @for (item of methodItems; track item.id) {
      <button type="button" class="method-item" [class.selected]="isSelected(item)" [class.wallet-item]="item.isWallet"
        [class.method-item--disabled]="item.isWallet && walletOptionDisabled"
        [disabled]="item.isWallet && walletOptionDisabled"
        (click)="onSelect(item)">
        <div class="method-main">
          <span class="method-label">{{ item.label | translate }}</span>

          @if (item.isWallet) {
          <div class="wallet-balance">
            <span class="wallet-currency">
              <app-riyal-symbol class="riyal-symbol"></app-riyal-symbol>
            </span>
            <span class="wallet-amount">
              @if (getWalletBalanceAmount() !== null) {
              {{ getWalletBalanceAmount() | number:'1.2-2' }}
              } @else {
              --
              }
            </span>
          </div>
          } @else {
          <div class="method-logos">
            @for (logoId of item.logoIds; track logoId) {
              @if (isLogoAvailable(logoId)) {
                <img [src]="getIconPath(logoId)" [alt]="logoId" class="logo-image" [class.wallet-logo]="logoId === 'WALLET'" />
              } @else {
                <span class="logo-fallback">{{ logoId === 'AMERICANEXPRESS' ? 'AMEX' : logoId }}</span>
              }
            }
          </div>
          }
        </div>

        <span class="selection-indicator" [class.active]="isSelected(item)"></span>
      </button>
    }
  </div>
</div>
